'use client';

import { useCustomLocale } from '@/_hooks/useCustomLocale';
import { IProduct } from '@/entities/product/model/types';
import { Avatar } from '@/components/ui/avatar';
import { Badge, Flex, HStack } from '@chakra-ui/react';

const Details = ({
  product,
  totalDiscount,
}: {
  product: Partial<IProduct>;
  totalDiscount: number;
}) => {
  const currentLocale = useCustomLocale();
  return (
    <HStack
      top={{ base: 3, lg: 6 }}
      left={{ base: 3, lg: 6 }}
      zIndex={1}
      position='absolute'
    >
      {product?.tags_obj && product?.tags_obj?.length > 0 && (
        <Flex rounded='full'>
          {product?.tags_obj?.map((tag) => (
            <Avatar
              bg={{ base: 'light', lg: 'white' }}
              opacity={{ base: 0.7, lg: 1 }}
              w={{ base: 6, lg: 8 }}
              h={{ base: 6, lg: 8 }}
              key={tag.slug}
              name={tag?.title?.[currentLocale]}
              src={tag.icon ? `${process.env.BASE_URL}${tag.icon}` : undefined}
            />
          ))}
        </Flex>
      )}
      {totalDiscount !== 0 && (
        <Badge
          rounded={'full'}
          variant='solid'
          bg='promo'
          color='#fff'
          size={{ base: 'sm', lg: 'md' }}
        >
          {((totalDiscount / (product?.out_price || 0)) * 100).toFixed(0)} %
        </Badge>
      )}
    </HStack>
  );
};

export default Details;
